import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useInitialization } from '../contexts/Initialization'
import { SETUP_MFA_ENFORCED } from '../constants/links'
import { navigateTo } from '../utils/redirect/navigator'
import { isMFAEnabled } from '../utils/isMFAEnabled'

export function computeShouldSetupMFA(user = {}) {
  const {
    mfa_enforced: mfaEnforced = false,
    local_login_enabled: isLocalLoginEnabled = false,
    enabled_mfa_mechanisms: enabledMFAMechanisms = [],
  } = user
  const hasMFAEnabled = isMFAEnabled(enabledMFAMechanisms, isLocalLoginEnabled)
  return mfaEnforced && !hasMFAEnabled
}

export function useAppInit() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useInitialization() || {}
  const shouldSetupMFA = computeShouldSetupMFA(user)

  useEffect(() => {
    if (shouldSetupMFA) {
      // SETUP_MFA_ENFORCED ('/users/settings/mfa') moved to the login app
      // (AUTHN-3512) — a client-side navigate can no longer reach it since
      // it's a different bundle, so this is a full page redirect.
      navigateTo(SETUP_MFA_ENFORCED)
    } else {
      navigate(
        {
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
        },
        { replace: true, state: { firstPage: true } },
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps, @eslint-react/x-exhaustive-deps, @eslint-react/exhaustive-deps
  }, [])
}
